export default __webpack_public_path__ + "static/media/a017-g.346ac2d4.svg";